import React from "react";
import { useHistory } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import { AuthProvider } from "./AuthContext";

const Auth0ProviderWithHistory = ({ children }) => {
  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const audience = process.env.REACT_APP_AUDIENCE;

  const history = useHistory();

  const onRedirectCallback = (appState) => {
    history.push(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      redirectUri={window.location.origin}
      onRedirectCallback={onRedirectCallback}
      audience={audience}
      scope="read:current_user update:current_user create:user_tickets read:logs read:logs_users read:roles read:users update:users read:role_members update:current_user_metadata read:current_user_metadata"
      cacheLocation="localstorage"
      useRefreshTokens={true}
    >
      <AuthProvider>{children}</AuthProvider>
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
